import BaseSubject from "./BaseSubject";
import type SettingsObserver from "../observers/SettingsObserver";

export default class SettingsSubject<T> extends BaseSubject<T, SettingsObserver<T>> {
    public static CLASS_NAME = "SettingsSubject";
}
